import { useMemo } from 'react';
import {
  MULTI_SHOP_BRAND_LOGO,
  SINGLE_SHOP_FALLBACK_LOGO,
} from '@core/config/constants';
import { MULTI_SHOP_ENABLED, getFirstShopId, getImageBaseForTenantShop } from '@core/config/shops';
import { checkingImageUrl } from '@shared/utils/imageUrlCheck';
import { useTenantShops } from './TenantShopsContext';

/**
 * Resolved header logo URL:
 * - Multi-shop: source-controlled marketplace brand logo from `public/`.
 * - Single-shop: shop `shop_logo` / `photo` via tenant CDN, else `public/` fallback.
 */
export function useHeaderLogoSrc(): string {
  const { shops } = useTenantShops();

  return useMemo(() => {
    if (MULTI_SHOP_ENABLED) {
      return MULTI_SHOP_BRAND_LOGO;
    }

    const sid = getFirstShopId(shops);
    const shop = shops.find((s) => s.id === sid);
    const ref = shop?.logoRef?.trim();
    if (!ref) return SINGLE_SHOP_FALLBACK_LOGO;
    const base = getImageBaseForTenantShop(shop?.id, shops);
    const url = checkingImageUrl(ref, base);
    return url || SINGLE_SHOP_FALLBACK_LOGO;
  }, [shops]);
}
